"use client";

import { Moon, Sun } from "lucide-react";
import { useLayoutEffect, useState } from "react";
import { useTheme } from "@/components/ThemeProvider";

export function ThemeToggle({
  className = "",
  compact = false,
}: {
  className?: string;
  compact?: boolean;
}) {
  const { theme, toggle } = useTheme();
  const [mounted, setMounted] = useState(false);

  useLayoutEffect(() => {
    setMounted(true);
  }, []);

  // SSR / esimene hydrate: alati sama (hele). Pärast mounti: tegelik teema.
  const dark = mounted && theme === "dark";
  const label = dark ? "Hele vaade" : "Tume vaade";

  return (
    <button
      type="button"
      className={`btn btn-ghost ${compact ? "px-2.5 py-2" : "w-full"} ${className}`}
      onClick={toggle}
      aria-label={label}
      title={label}
    >
      {dark ? <Sun size={compact ? 16 : 14} /> : <Moon size={compact ? 16 : 14} />}
      {!compact && label}
    </button>
  );
}
